(() => {
  const imageOpener = (target) => target && target.closest && target.closest('modal-opener.product__modal-opener--image');

  document.addEventListener('click', (event) => {
    const opener = imageOpener(event.target);
    if (!opener) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const opener = imageOpener(event.target);
    if (!opener) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }, true);
})();
